// extracted by mini-css-extract-plugin
export default {"speaker":"RulesPageTableActionsCell_speaker__Am7DN"};